import React, { useEffect, useState } from 'react'
import { useMutation } from '@apollo/client'
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import { useTranslation } from 'react-i18next'
import { useForm } from 'react-hook-form'

import { CompanyForm } from 'features/MainRouter/components/create-company-modals/CreateCompanyModal/components'
import { UpdateCompany, UpdateCompanyVariables, UPDATE_COMPANY } from 'api'
import { GraphQLUtils } from 'utils'

interface FormType {
  companyName: string
  country: string
}

interface Props {
  companyId: number
  data: { companyName?: string; logo?: string; countryId?: string }
  isReadOnly: boolean
}

export const UpdateCompanyForm: React.FC<Props> = ({ companyId, data, isReadOnly }) => {
  const [image, setImage] = useState<string>()
  const { t: commonT } = useTranslation('common')

  const [updateCompany] = useMutation<UpdateCompany, UpdateCompanyVariables>(UPDATE_COMPANY, {
    onError: GraphQLUtils.errorHandler,
  })

  const validationSchema = yup.object().shape({
    companyName: yup.string().required(commonT('validations.required')),
    country: yup.string().required(commonT('validations.required')),
  })

  const { control, handleSubmit, reset } = useForm({
    resolver: yupResolver<FormType>(validationSchema),
    defaultValues: {
      companyName: data.companyName ?? '',
      country: data.countryId!,
    },
  })

  useEffect(() => {
    reset({ companyName: data.companyName, country: data.countryId })
  }, [reset, data])

  return (
    <CompanyForm
      isCreateCompanyMode={false}
      image={image ?? data.logo}
      onImageChange={(imageResult, file) => {
        setImage(imageResult)
        updateCompany({ variables: { id: companyId, updateCompanyDTO: { logo: file } } })
      }}
      control={control}
      onInputNameBlur={handleSubmit(({ companyName }) => {
        updateCompany({ variables: { id: companyId, updateCompanyDTO: { name: companyName } } })
      })}
      isReadyOnly={isReadOnly}
      selectedCompanyCountry={data.countryId}
    />
  )
}
